<template>
  <div>
    <!-- 顶部信息栏 -->
    <div class="top-bar">
      <div class="container top-bar-content">
        <div class="flex-center" style="gap: 8px;">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
          </svg>
          <span>客服电话：400-655-4008</span>
        </div>
      </div>
    </div>

    <!-- 头部 Logo与搜索 -->
    <header class="header">
      <div class="container header-inner">
        <div class="logo-group">
          <img :src="logo" alt="弘善庆堂互联网医院" class="logo-main">
          <img :src="logomid" alt="互联网医院" class="logo-mid-mobile">
        </div>
        
        <img :src="logomid" alt="互联网医院" class="logo-mid-desktop">
        
        <div class="search-box">
          <span style="color: var(--text-muted); margin-right: 8px;">站内搜索：</span>
          <div class="search-input-group">
            <input type="text" placeholder="请输入检索关键..." v-model="searchKeyword">
            <button @click="handleSearch">
              <svg fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path>
              </svg>
              搜索
            </button>
          </div>
        </div>
      </div>
    </header>

    <!-- 导航栏 -->
    <nav class="nav-bar">
      <div class="container">
        <ul class="nav-list hide-scrollbar">
          <li v-for="(item, idx) in navList" :key="idx">
            <a href="#" :class="{ active: item.active }" @click.prevent="setActiveNav(idx)">{{ item.name }}</a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Banner 与快捷入口 -->
    <section class="banner-section">
      <img :src="getImgUrl(banner && banner.coverImage)" alt="医院团队" class="banner-img">

      <div class="quick-links">
        <div class="quick-links-bg-circle circle-1"></div>
        <div class="quick-links-bg-circle circle-2"></div>

        <a v-for="(item, idx) in shortcuts" :key="idx" href="#" class="quick-link-item" @click.prevent="goPageDetail(item)">
          <img :src="getImgUrl(item.coverImage)" :alt="item.name" class="quick-link-img">
        </a>
      </div>
    </section>

    <!-- 资讯卡片区域 -->
    <div class="news-section-wrapper">
      <section class="news-section">
        <div class="news-grid">
          <div class="news-card" v-for="(item, idx) in infoCards" :key="idx">
            <div class="news-img-wrap">
              <img :src="getImgUrl(item.coverImage)" :alt="item.name">
            </div>
            <div class="news-content">
              <div class="news-header">
                <h3 class="news-title">{{ item.name }}</h3>
                <a href="#" class="news-more" @click.prevent="goArticleList(item.code, item.name)">更多 >></a>
              </div>
              <ul class="news-list">
                <li v-for="(article, articleIdx) in item.articles" :key="articleIdx" class="truncate" @click="goArticleDetail(article.id)" style="cursor:pointer;">
                  {{ article.title }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 科室导航区域 -->
    <section id="departments-section" class="container departments-section">
      <div class="dept-card">
        <div class="dept-bg" ></div>
        
        <img :src="imgUrl+'/systemImg/ysxm.png'" alt="装饰" class="dept-deco-left">
        <img :src="imgUrl+'/systemImg/xm.png'" alt="装饰" class="dept-deco-right">

        <div class="dept-content">
          <div class="dept-title-wrap">
            <img :src="imgUrl+'/systemImg/tmNew.png'" alt="科室导航" class="dept-title-img">
          </div>

          <div class="dept-layout">
            <div class="dept-grid">
              <a v-for="(item, idx) in departments" :key="idx" href="#" class="dept-item" @click.prevent="goPageDetail(item)">
                <img :src="getImgUrl(item.coverImage)" :alt="item.name">
              </a>
            </div>
            <div class="dept-image-right">
              <img :src="imgUrl+'/systemImg/zh.png'" alt="医疗特色">
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 医生团队区域 -->
    <section id="doctors-section" class="container doctors-section">
      <div class="doc-section-header">
        <div class="section-title" style="margin-bottom: 0;">
          <img :src="imgUrl+'/systemImg/doc1.png'" alt="名医团队">
        </div>
      </div>

      <div class="carousel-wrapper">
        <button class="carousel-btn btn-left" @click="scrollDoctors(-1)">❮</button>

        <div class="doc-marquee-wrapper">
          <div class="doc-marquee-track" ref="doctorTrack" :style="doctorMarqueeStyle">
            <div class="doc-marquee-list">
            <div class="doc-card" v-for="(item, idx) in doctors" :key="'a-'+idx" @click="goPageDetail(item)" style="cursor:pointer;">
              <div class="doc-img-box"><img :src="getImgUrl(item.coverImage)" :alt="item.name"></div>
              <div class="doc-info">
                <span class="doc-name">{{ item.doctorName || item.name }}</span>
                <span class="doc-divider">|</span>
                <span class="doc-title">{{ item.position  }}</span>
              </div>
            </div>
          </div>
          <div class="doc-marquee-list" aria-hidden="true">
            <div class="doc-card" v-for="(item, idx) in doctors" :key="'b-'+idx" @click="goPageDetail(item)" style="cursor:pointer;">
              <div class="doc-img-box"><img :src="getImgUrl(item.coverImage)" :alt="item.name"></div>
              <div class="doc-info">
                <span class="doc-name">{{ item.doctorName || item.name }}</span>
                <span class="doc-divider">|</span>
                <span class="doc-title">{{ item.position  }}</span>
              </div>
            </div>
          </div>
        </div>
        </div>

        <button class="carousel-btn btn-right" @click="scrollDoctors(1)">❯</button>
      </div>
    </section>

    <!-- 药材地图区域 -->
    <section style="background-color: var(--brand-bg-gray);">
      <div class="container map-section">
        <div class="section-title" style="margin-bottom: 32px;">
          <img :src="imgUrl+'/systemImg/doc2.png'" alt="道地药材">
        </div>
        <div class="map-wrapper">
          <img :src="getImgUrl(map && map.coverImage, 'system')" alt="药材基地分布中国地图">
        </div>
      </div>
    </section>

    <!-- 证书区域 -->
    <section class="container cert-section">
      <div class="section-title" style="margin-bottom: 32px;">
        <img :src="imgUrl+'/systemImg/doc3.png'" alt="信任背书">
      </div>

      <div class="cert-grid">
        <div class="cert-item" v-for="(item, idx) in certificates" :key="idx">
          <img :src="getImgUrl(item.coverImage)" alt="证书">
        </div>
      </div>
    </section>

    <!-- 公益轮播区域 -->
    <section class="container social-section">
      <div class="section-title" style="margin-bottom: 32px;">
        <img :src="imgUrl+'/systemImg/doc4.png'" alt="社会责任与公益">
      </div>

      <div class="carousel-wrapper">
        <button class="carousel-btn btn-left" @click="scrollSocial(-1)">❮</button>

        <div class="social-marquee-wrapper">
          <div class="social-marquee-track" ref="socialTrack" :style="socialMarqueeStyle">
            <div class="social-marquee-list">
              <div class="social-card" v-for="(item, idx) in socialItems" :key="'a-'+idx">
                <img :src="getImgUrl(item.coverImage)" alt="公益活动">
              </div>
            </div>
            <div class="social-marquee-list" aria-hidden="true">
              <div class="social-card" v-for="(item, idx) in socialItems" :key="'b-'+idx">
                <img :src="getImgUrl(item.coverImage)" alt="公益活动">
              </div>
            </div>
          </div>
        </div>

        <button class="carousel-btn btn-right" @click="scrollSocial(1)">❯</button>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container footer-content">
        <div class="footer-flex">
          
          <div class="footer-left-group">
            <div class="footer-illustration">
              <img :src="imgUrl+'/systemImg/foot3.png'" alt="中医插画">
            </div>
            <div class="qr-group">
              <div class="qr-box"><img :src="imgUrl+'/systemImg/xcx.png'" alt="小程序二维码"></div>
              <div class="qr-box"><img :src="imgUrl+'/systemImg/gzh.png'" alt="公众号二维码"></div>
            </div>
          </div>

          <div class="footer-right-group">
            <div class="footer-img-row">
              <img :src="imgUrl+'/systemImg/foot1.png'" alt="资质荣誉" class="footer-img-1">
            </div>
            <div class="footer-img-row">
              <img :src="imgUrl+'/systemImg/foot2.png'" alt="联系方式与地址" class="footer-img-2">
            </div>
          </div>
          
        </div>
      </div>

      <div class="copyright container">
        Copyright © 2025hongshanqingtang.com 版权所有. 鄂ICP备05019014号-1 鄂公网安备 35020302033006号
      </div>
    </footer>
  </div>
</template>

<script>
import logo from '@/assets/logo.jpg'
import logomid from '@/assets/logomid.png'
import { cdnUrl } from '@/utils/commons.js'
import {
  getHomeData,
  getHomeHeader,
  getHomeInfoCards,
  getHomeDepartments,
  getHomeDoctors,
  getHomeFooter
} from '@/api/page'

export default {
  name: 'HospitalWebsite',
  data() {
    return {
      logo: logo,
      logomid: logomid,
      imgUrl: cdnUrl + '/netImg',
      searchKeyword: '',
      banner: null,
      shortcuts: [],
      infoCards: [],
      navs: [],
      departments: [],
      doctors: [],
      map: null,
      certificates: [],
      socialItems: [],
      isDoctorScrolling: false,
      isSocialScrolling: false
    }
  },
  computed: {
    navList() {
      const list = [{ name: '首页', active: true }]
      if (this.navs) {
        this.navs.forEach(nav => {
          list.push({ name: nav.name, active: false, code: nav.code, id: nav.id })
        })
      }
      return list
    },
    doctorMarqueeStyle() {
      const count = this.doctors ? this.doctors.length : 0
      const duration = count > 0 ? count * 6 : 30
      return {
        animationDuration: `${duration}s`
      }
    },
    socialMarqueeStyle() {
      const count = this.socialItems ? this.socialItems.length : 0
      const duration = count > 0 ? count * 6 : 30
      return {
        animationDuration: `${duration}s`
      }
    }
  },
  created() {
    this.fetchHomeData()
  },
  watch: {
    '$route.query.section'() {
      this.checkScrollToSection()
    }
  },
  methods: {
    async fetchHomeData() {
      try {
        const [headerRes, infoCardsRes, departmentsRes, doctorsRes, footerRes] = await Promise.all([
          getHomeHeader(),
          getHomeInfoCards(),
          getHomeDepartments(),
          getHomeDoctors(),
          getHomeFooter()
        ])

        const header = headerRes.data || {}
        this.banner = header.banner || null
        this.shortcuts = header.shortcuts || []
        this.navs = header.navs || []

        const infoCards = infoCardsRes.data || {}
        this.infoCards = infoCards.infoCards || []

        const departments = departmentsRes.data || {}
        this.departments = departments.departments || []

        const doctors = doctorsRes.data || {}
        this.doctors = doctors.doctors || []

        const footer = footerRes.data || {}
        this.map = footer.map || null
        this.certificates = footer.certificates || []
        this.socialItems = footer.socialItems || []
      } catch (e) {
        console.error('获取首页数据失败', e)
        // 降级：如果拆分接口失败，尝试旧的大接口
        try {
          const res = await getHomeData()
          const data = res.data || {}
          this.banner = data.banner || null
          this.shortcuts = data.shortcuts || []
          this.navs = data.navs || []
          this.infoCards = data.infoCards || []
          this.departments = data.departments || []
          this.doctors = data.doctors || []
          this.map = data.map || null
          this.certificates = data.certificates || []
          this.socialItems = data.socialItems || []
        } catch (err) {
          console.error('降级获取首页数据也失败', err)
        }
      }
      this.$nextTick(() => {
        this.checkScrollToSection()
      })
    },
    getImgUrl(coverImage) {
      if (!coverImage) return ''
      if (coverImage.startsWith('http')) return coverImage
      return this.imgUrl + coverImage
    },
    setActiveNav(idx) {
      this.navList.forEach((item, index) => {
        item.active = (index === idx)
      })
      const item = this.navList[idx]
      if (idx === 0) {
        if (this.$route.path !== '/') {
          this.$router.push('/')
        }
      } else if (item.name === '名医团队') {
        this.$router.push({ path: '/', query: { section: 'doctors' } })
      } else if (item.name === '科室介绍') {
        this.$router.push({ path: '/', query: { section: 'departments' } })
      } else if (item.id) {
        this.$router.push('/page/detail/' + item.id)
      }
    },
    goPageDetail(item) {
      if (item && item.id) {
        this.$router.push('/page/detail/' + item.id)
      }
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        alert(`搜索：${this.searchKeyword}`)
      } else {
        alert('请输入搜索关键词')
      }
    },
    goArticleDetail(id) {
      this.$router.push('/article/detail/' + id)
    },
    goArticleList(code, title) {
      this.$router.push('/article/' + code + '?title=' + encodeURIComponent(title))
    },
    scrollDoctors(direction) {
      this.scrollMarquee('doctor', this.$refs.doctorTrack, direction)
    },
    scrollSocial(direction) {
      this.scrollMarquee('social', this.$refs.socialTrack, direction)
    },
    scrollMarquee(type, track, direction) {
      const flagKey = type === 'doctor' ? 'isDoctorScrolling' : 'isSocialScrolling'
      if (this[flagKey]) return
      this[flagKey] = true

      if (!track) {
        this[flagKey] = false
        return
      }

      const list = track.querySelector('.doc-marquee-list') || track.querySelector('.social-marquee-list')
      if (!list) {
        this[flagKey] = false
        return
      }

      const computedStyle = window.getComputedStyle(track)
      const matrix = new DOMMatrix(computedStyle.transform)
      const currentX = Math.abs(matrix.m41)

      const card = list.querySelector('.doc-card') || list.querySelector('.social-card')
      const cardWidth = card ? card.offsetWidth : 300
      const gap = parseInt(window.getComputedStyle(list).gap) || 26
      const step = (cardWidth + gap) * 2

      let targetX = currentX + direction * step
      const listWidth = list.offsetWidth
      const duration = parseFloat(computedStyle.animationDuration) * 1000

      if (targetX < 0) targetX += listWidth
      if (targetX >= listWidth * 2) targetX -= listWidth

      track.style.animationPlayState = 'paused'

      const startX = currentX
      const distance = targetX - startX
      const animDuration = 500
      const startTime = performance.now()

      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

      const frame = (now) => {
        const elapsed = now - startTime
        const t = Math.min(elapsed / animDuration, 1)
        const x = startX + distance * easeOutCubic(t)
        track.style.transform = `translateX(-${x}px)`

        if (t < 1) {
          requestAnimationFrame(frame)
        } else {
          let finalX = targetX
          if (finalX >= listWidth) {
            finalX -= listWidth
            track.style.transform = `translateX(-${finalX}px)`
          }

          const progress = finalX / listWidth
          const delay = -progress * duration
          track.style.animationDelay = `${delay}ms`
          track.style.transform = ''
          track.style.animationPlayState = 'running'
          this[flagKey] = false
        }
      }

      requestAnimationFrame(frame)
    },
    checkScrollToSection() {
      const section = this.$route.query.section
      if (!section) return
      this.$nextTick(() => {
        const el = document.getElementById(section + '-section')
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      })
    }
  }
}
</script>

<style scoped>
/* ================= 重置与基础缩放 ================= */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: system-ui, -apple-system, sans-serif;
  color: var(--text-main);
  background-color: var(--brand-bg-gray);
  line-height: 1.5;
}

a { text-decoration: none; color: inherit; }
ul { list-style: none; }
img { max-width: 100%; height: auto; display: block; }

/* ================= 公共布局类 - 扩大容器 ================= */
.container {
  max-width: 1820px;  /* 从1400px增加到1820px (+30%) */
  width: 100%;
  margin: 0 auto;
  padding: 0 42px;  /* 从32px增加到42px */
}

.flex-center { 
  display: flex; 
  align-items: center; 
  justify-content: center; 
}
.flex-between { 
  display: flex; 
  align-items: center; 
  justify-content: space-between; 
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

/* ================= 顶部信息栏 ================= */
.top-bar {
  background-color: var(--brand-red);
  color: white;
  font-size: 18px;  /* 从14px增加到18px */
  padding: 16px 0;  /* 从12px增加到16px */
  position: relative;
  z-index: 10;
}
.top-bar-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;  /* 从12px增加到16px */
}
.top-bar svg { width: 22px; height: 22px; }  /* 从18px增加到22px */

/* ================= 头部 (Logo与搜索) ================= */
.header {
  padding: 28px 0;  /* 从20px增加到28px */
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 20;
}
.header-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  min-height: 91px;  /* 从70px增加到91px */
}
.logo-group {
  display: flex;
  align-items: center;
  gap: 16px;  /* 从12px增加到16px */
  position: relative;
  z-index: 30;
  margin-left: 48px;  /* 从32px增加到48px */
}
.logo-main {
  height: 130px;  /* 从100px增加到130px */
  width: auto;
  object-fit: contain;
  margin-top: -52px;  /* 从-40px增加到-52px */
  filter: drop-shadow(0 6px 5px rgba(0,0,0,0.08));
  background: white;
  border-radius: 50%;
  flex-shrink: 0;
}
.logo-mid-mobile { height: 65px; }  /* 从50px增加到65px */
.logo-mid-desktop { display: none; }

.search-box { display: none; }

/* ================= 导航栏 ================= */
.nav-bar {
  top: 0;
  z-index: 40;
  margin-bottom: 10px;
}
.nav-list {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  justify-content: space-between;
  font-size: 19px;  /* 从15px增加到19px */
  font-weight: 500;
  color: var(--brand-red);
}
.nav-list li { flex: 1; text-align: center; }
.nav-list a {
  display: inline-block;
  padding: 16px 14px;  /* 从12px 10px增加到16px 14px */
  transition: color 0.3s;
}
.nav-list a:hover { color: var(--brand-red); }
.nav-list a.active {
  font-weight: 700;
  border-bottom: 3px solid var(--brand-red);  /* 从2px增加到3px */
}

/* ================= Banner 与 快捷入口 ================= */
.banner-section {
  position: relative;
  width: 100%;
  max-width: 1820px;  /* 从1400px增加到1820px */
  margin: 0 auto;
  background-color: white;
}
.banner-img {
  width: 100%;
  /* height: 365px; */
  object-fit: cover;
  border-radius: 16px;  /* 从12px增加到16px */
}
.quick-links {
  position: absolute;
  bottom: -104px;  /* 从-80px增加到-104px */
  left: 50%;
  transform: translateX(-50%);
  width: 95%;
  max-width: 1430px;  /* 从1100px增加到1430px */
  background: linear-gradient(to right, #a81218, #c8161d, #a81218);
  border-radius: 21px;  /* 从16px增加到21px */
  box-shadow: 0 40px 70px -18px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 52px;  /* 从40px增加到52px */
  padding: 36px 32px;  /* 从28px 24px增加到36px 32px */
  z-index: 10;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.25);
}
.quick-links-bg-circle {
  position: absolute;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 50%;
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
}
.circle-1 { right: -70px; width: 280px; height: 280px; }  /* 从220px增加到280px */
.circle-2 { right: -35px; width: 180px; height: 180px; }  /* 从140px增加到180px */
.quick-link-item { 
  position: relative; 
  z-index: 10; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
}
.quick-link-img { height: 90px; transition: transform 0.3s; }  /* 从70px增加到90px */
.quick-link-item:hover .quick-link-img { transform: scale(1.1); }

/* ================= 资讯卡片区域 ================= */
.news-section-wrapper { padding-bottom: 70px; }  /* 从55px增加到70px */
.news-section {
  width: 90%;
  max-width: 1430px;  /* 从1100px增加到1430px */
  margin: 0 auto;
  padding-top: 130px;  /* 从100px增加到130px */
}
.news-grid { display: grid; grid-template-columns: 1fr; gap: 26px; }  /* 从20px增加到26px */
.news-card {
  background: white;
  border-radius: 20px;  /* 从16px增加到20px */
  box-shadow: 0 6px 25px -8px rgba(0,0,0,0.12);
  border: 1px solid var(--border-color);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.3s;
}
.news-card:hover { 
  box-shadow: 0 30px 40px -12px rgba(0, 0, 0, 0.2); 
}
.news-img-wrap { height: 260px; background: #f3f4f6; overflow: hidden; }  /* 从200px增加到260px */
.news-img-wrap img { width: 100%; height: 100%; object-fit: cover; }
.news-content { padding: 28px; display: flex; flex-direction: column; flex-grow: 1; }  /* 从22px增加到28px */
.news-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 18px;  /* 从14px增加到18px */
  text-align: left;
}
.news-title {
  font-weight: bold;
  font-size: 24px;
  letter-spacing: 0.5px;
  text-align: left;
  flex: 1;
}  /* 从18px增加到24px */
.news-more { font-size: 14px; color: var(--text-muted); transition: color 0.3s; }  /* 从13px增加到14px */
.news-more:hover { color: var(--brand-red); }
.news-list { 
  font-size: 15px;  /* 从13px增加到15px */
  color: #4b5563; 
  display: flex; 
  flex-direction: column; 
  flex-grow: 1; 
}
.news-list li {
  border-bottom: 1px dashed #d1d5db;
  padding: 14px 0;
  cursor: pointer;
  transition: color 0.3s;
  text-align: left;
}
.news-list li:hover { color: var(--brand-red); }

/* ================= 科室导航区域 ================= */
.departments-section { margin: 85px auto; }  /* 从65px增加到85px */
.dept-card {
  position: relative;
  border-radius: 24px;  /* 从18px增加到24px */
  box-shadow: 0 30px 45px -12px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  /* background-color: rgba(200, 22, 29, 0.95); */
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255,255,255,0.25);
}
.dept-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 1;
  background-image: url('~@/assets/jb.png');
  background-size: cover;
  mix-blend-mode: multiply;
}
.dept-content { 
  position: relative; 
  z-index: 10; 
  /* padding: 42px; */
  width: 80%;
}
.dept-title-wrap { 
  display: flex; 
  align-items: center; 
  /* margin-bottom: 12px; */
  width: 100%;
}

.dept-deco-left {
  position: absolute;
  left: 25px;
  top: 5%;
  width: 180px;  /* 从140px增加到180px */
  z-index: 5;
  pointer-events: none;
  align-items: flex-end;
}

.dept-deco-right {
  position: absolute;
  right: 25px;
  bottom: 0px;
  width: 180px;  /* 从140px增加到180px */
  z-index: 5;
  pointer-events: none;
}

.dept-title-img {
  width: auto;
  max-width: 100%;
  position: relative;
  z-index: 10;
  background-color: transparent !important;
  mix-blend-mode: multiply;
}

.dept-layout { 
  display: flex; 
  flex-direction: column; 
  gap: 45px;  /* 从35px增加到45px */
  justify-content: space-between; 
}
.dept-grid { 
  width: 110%; 
  display: grid; 
  grid-template-columns: repeat(2, 1fr); 
  gap: 20px;
}
.dept-item {
  display: block;
  width: 110%;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 15px 25px -10px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255,255,255,0.4);
  transition: transform 0.3s;
}
.dept-item:hover { transform: translateY(-7px); }  /* 从-5px增加到-7px */
.dept-item img { 
  min-width: 100%;
  /* min-height: 100%; */
  object-fit: cover;  /* 图片裁剪填满 */
  object-position: center;
  display: block;
}
.dept-image-right { 
  width: 100%; 
  display: flex; 
  justify-content: center;
  overflow: hidden;
}
.dept-image-right img { 
  width: 90%;
  /* max-width: 780px; */
  object-fit: contain; 
}  /* 从450px增加到580px */

/* ================= 标题图片通用 ================= */
.section-title { margin-bottom: 52px; position: relative; z-index: 10; }  /* 从40px增加到52px */
.section-title img { height: 45px; max-width: 100%; }  /* 从35px增加到45px */

/* ================= 医生团队区域 ================= */
.doctors-section { padding-bottom: 70px; }
.doc-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}
.doc-marquee-wrapper {
  overflow: hidden;
  width: 100%;
  mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
}
.doc-marquee-track {
  display: flex;
  width: max-content;
  animation: marquee-scroll linear infinite;
}
.doc-marquee-wrapper:hover .doc-marquee-track {
  animation-play-state: paused;
}
.doc-marquee-list {
  display: flex;
  flex-shrink: 0;
  gap: 26px;
  padding: 0 13px;
}
@keyframes marquee-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.doc-card {
  display: flex;
  flex-direction: column;
  width: calc((100vw - 84px - 104px) / 2);
  max-width: 332px;
  flex-shrink: 0;
}
.doc-img-box {
  aspect-ratio: 6/8;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;  /* 从8px增加到10px */
  border: 1px solid #f3f4f6;
  background-color: #eff6ff;
}
.doc-img-box img { width: 100%; height: 100%; object-fit: cover; object-position: top; }
.doc-info {
  margin-top: 16px;  /* 从12px增加到16px */
  width: 100%;
  padding-bottom: 10px;  /* 从8px增加到10px */
  border-bottom: 2px solid rgba(168, 18, 24, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;  /* 从6px增加到8px */
}
.doc-name { font-weight: bold; font-size: 17px; color: var(--text-main); }  /* 从13px增加到17px */
.doc-divider { color: #d1d5db; font-size: 13px; }  /* 从10px增加到13px */
.doc-title { font-size: 15px; color: #4b5563; }  /* 从12px增加到15px */

/* ================= 药材地图区域 ================= */
.map-section { padding: 70px 42px; }  /* 从55px增加到70px */
.map-wrapper { 
  width: 100%; 
  display: flex; 
  justify-content: center; 
  border-radius: 14px;  /* 从11px增加到14px */
  overflow: hidden; 
  /* box-shadow: 0 15px 25px -10px rgba(0, 0, 0, 0.12); */
}
.map-wrapper img { width: 100%; max-width: 1820px; object-fit: contain; }  /* 从1400px增加到1820px */

/* ================= 证书区域 ================= */
.cert-section { padding: 56px 0; }
.cert-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 24px; }
.cert-item {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #f3f4f6;
}
.cert-item img { width: 100%; height: 100%; object-fit: cover; transition: transform 0.5s; }
.cert-item:hover img { transform: scale(1.05); }

.carousel-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.carousel-btn {
  position: absolute;
  z-index: 10;
  width: 45px;
  height: 45px;
  background: rgba(0,0,0,0.3);
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  box-shadow: 0 12px 20px -6px rgba(0, 0, 0, 0.15);
}
.carousel-btn:hover { background: var(--brand-red); }
.btn-left { left: 0; margin-left: -50px; }
.btn-right { right: 0; margin-right: -50px; }

/* ================= 公益轮播区域 ================= */
.social-section { padding: 56px 42px; margin-bottom: 32px; }
.social-marquee-wrapper {
  overflow: hidden;
  width: 100%;
  mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, black 5%, black 95%, transparent);
}
.social-marquee-track {
  display: flex;
  width: max-content;
  animation: marquee-scroll linear infinite;
}
.social-marquee-wrapper:hover .social-marquee-track {
  animation-play-state: paused;
}
.social-marquee-list {
  display: flex;
  flex-shrink: 0;
  gap: 24px;
  padding: 0 12px;
}
.social-card {
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 8px 16px -6px rgba(0, 0, 0, 0.12);
  width: calc((100vw - 84px - 72px) / 2);
  max-width: 430px;
  flex-shrink: 0;
}
.social-card img {
  width: 100%;
  height: 185px;
  object-fit: cover;
  transition: transform 0.5s;
  display: block;
}
.social-card:hover img { transform: scale(1.05); }

/* ================= 页脚 ================= */
.footer { background-color: var(--brand-red); color: white; margin-top: 70px; }  /* 从55px增加到70px */
.footer-content { padding: 32px; }  /* 从25px增加到32px */
.footer-flex { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: center; 
  gap: 45px;  /* 从35px增加到45px */
}

.footer-left-group { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: center; 
  gap: 35px;  /* 从27px增加到35px */
}
.footer-illustration { width: 175px; flex-shrink: 0; display: flex; justify-content: center; }  /* 从135px增加到175px */
.footer-illustration img { opacity: 0.9; }
.qr-group { display: flex; gap: 26px; }  /* 从20px增加到26px */
.qr-box { 
  width: 140px;  /* 从108px增加到140px */
  display: flex; 
  justify-content: center; 
  align-items: center;
  border-radius: 10px;  /* 从8px增加到10px */
  border: 1px solid white;
  padding: 7px;  /* 从5px增加到7px */
}

.footer-right-group { 
  display: flex; 
  flex-direction: column; 
  align-items: center; 
  justify-content: center; 
  gap: 35px;  /* 从27px增加到35px */
}
.footer-img-row { display: flex; justify-content: center; }
.footer-img-row img { width: 100%; }
.footer-img-1 { max-width: 750px; }  /* 从580px增加到750px */
.footer-img-2 { max-width: 750px; }  /* 从580px增加到750px */

.copyright {
  border-top: 1px solid rgba(255,255,255,0.3);
  background-color: var(--brand-red);
  padding: 18px;  /* 从14px增加到18px */
  text-align: center;
  font-size: 13px;  /* 从10px增加到13px */
  color: rgba(255,255,255,0.8);
  font-weight: 300;
  letter-spacing: 0.5px;
}

/* ================= 响应式媒体查询 ================= */
@media (min-width: 768px) {
  .top-bar { font-size: 20px; }
  .header { padding: 32px 0; }
  .header-inner { min-height: 104px; }
  .logo-group { margin-left: 156px; }
  .logo-main { height: 182px; margin-top: -78px; }
  .logo-mid-mobile { display: none; }
  .logo-mid-desktop {
    display: block;
    height: 84px;
    position: absolute;
    left: 48%;
    transform: translateX(-50%);
    z-index: 20;
  }
  .search-box {
    display: flex;
    align-items: center;
    font-size: 16px;
    z-index: 20;
  }
  .search-input-group {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    border-radius: 7px;
    overflow: hidden;
  }
  .search-input-group input { 
    padding: 9px 14px; 
    outline: none; 
    width: 240px; 
    border: none; 
    font-size: 15px;
  }
  .search-input-group button {
    background: var(--brand-red);
    color: white;
    padding: 9px 22px;
    border: none;
    cursor: pointer;
    transition: background 0.3s;
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .search-input-group button:hover { background: var(--brand-dark-red); }
  .search-input-group svg { width: 19px; height: 19px; margin-right: 7px; }

  .nav-list { font-size: 20px; }
  .banner-img { height: 520px; }
  .quick-links { bottom: -110px; gap: 85px; padding: 42px 28px; }
  .circle-1 { width: 420px; height: 420px; right: -70px; }
  .circle-2 { width: 300px; height: 300px; right: -35px; }
  .quick-link-img { height: 130px; }

  .news-section { width: 90%; padding-top: 145px; }
  .news-grid { grid-template-columns: repeat(3, 1fr); }
  .news-img-wrap { height: 285px; }
  .news-title { font-size: 26px; text-align: left; }
  .news-list { font-size: 16px; }

  .dept-content { padding: 100px; }
  
  .section-title img { height: 60px; }
  
  .doctors-section { padding-bottom: 85px; }
  .doc-card { width: calc((100vw - 84px - 120px) / 5); max-width: 332px; }
  .doc-marquee-list { gap: 30px; padding: 0 15px; }
  .doc-name { font-size: 18px; }
  .doc-title { font-size: 16px; }

  .map-section { padding: 70px 42px; }
  
  .cert-section { padding: 70px 42px; }
  .cert-grid { grid-template-columns: repeat(4, 1fr); gap: 32px; }

  .carousel-btn { width: 50px; height: 50px; }
  .btn-left { margin-left: -80px; }
  .btn-right { margin-right: -80px; }

  .social-card { width: calc((100vw - 84px - 96px) / 4); max-width: 430px; }
  .social-marquee-list { gap: 32px; padding: 0 16px; }
  .social-card img { height: 245px; }

  .footer-content { padding: 40px 28px; }
  .footer-left-group { flex-direction: row; }
  .footer-illustration { width: 195px; }
  .qr-box { width: 155px; }
  .copyright { font-size: 14px; }
}

@media (min-width: 1024px) {
  .banner-img { height: 100%; }
  .quick-links { gap: 130px; }
  .dept-content { 
    /* padding: 65px 65px; */
    /* max-width: 1050px; */
    margin: 0 auto;
  }
  .dept-layout { 
    flex-direction: row; 
    justify-content: flex-start;
    gap: 55px; 
    align-items: flex-end; 
  }
  .dept-grid { 
    width: 110%; 
    gap: 55px; 
  }
  .dept-image-right { 
    width: 100%; 
    /* justify-content: flex-start; */
  }
}

@media (min-width: 1280px) {
  .footer-flex { flex-direction: row; gap: 85px; }
}
</style>